import * as React from 'react';
import { ValidationResult } from 'sos-common/js/commonTypes/validation.types';
import ClarificationItem from './clarificationItem';
import { RegBoundClarification, RegisterPeriodClarificationItemStrings } from './Clarification.types';
import { hashCode } from 'sos-common/js/utils/hash';
import { HTMLAttributes } from 'react';

export interface ClariFicationListStrings {
  title: string;
}
export interface ClariFicationListProps {
  id?: string,
  regBoundClarifications: RegBoundClarification[];
  onChange?(selectedRegisters: RegBoundClarification[]): void;
  strings: RegisterPeriodClarificationItemStrings & ClariFicationListStrings;
  validationResults?: ValidationResult[];
  fieldName?: string;
  touchedCallback?: () => void;
  errorAriaAttributes: HTMLAttributes<any>;
}

export interface ClarificationListState {
  // regBoundClarifications: RegBoundClarification[];
}

export default class ClarificationList extends React.Component<ClariFicationListProps, ClarificationListState> {
  static defaultProps = {
    fieldName: ''
  }

  private _id: string;

  constructor(props: any) {
    super(props);
    this._id = props.id || hashCode(props.strings.title, 'ClarificationList');
  }


  handleChange = (regBoundClarifications: RegBoundClarification[]) => {
    this.props.onChange(regBoundClarifications);
    if(this.props.touchedCallback)
      this.props.touchedCallback();
  }
  
  handleRemove = (index: number) => {
      const newBoundClaris = this.props.regBoundClarifications.slice();
      const itemIndex = newBoundClaris.findIndex(c => c.index === index);
      const item = {...newBoundClaris[itemIndex]};
      item.clarification = undefined;
      newBoundClaris[itemIndex] = item;
      this.handleChange(newBoundClaris);
  };
  handleUpdate = (regBoundClari: RegBoundClarification) => {
      const newBoundClaris = this.props.regBoundClarifications.slice();
      const itemIndex = newBoundClaris.findIndex(c => c.index === regBoundClari.index);
      // const item = {...newBoundClaris[itemIndex]};
      // item.clarification = regBoundClari.clarification;
      newBoundClaris[itemIndex] = regBoundClari;
      
    this.handleChange(newBoundClaris)
  };
  public render() {
    const { strings, errorAriaAttributes, regBoundClarifications } = this.props;
    
    return (
      <div role="group" aria-labelledby={this._id}>
        <h3 id={this._id}>{strings.title}</h3>
        {regBoundClarifications.map(reg => (
          <ClarificationItem
            key={reg.DhsId}
            onUpdate={this.handleUpdate}
            reg={reg}
            strings={strings}
            errorAriaAttributes={errorAriaAttributes}
          />
        ))}
      </div>
    );
  }
}
